var dashboards = {};
dashboards.db = null;
dashboards.init = async function(parent) {
  this.db = parent.fb;
  this.parent = parent;
  this.email = await parent.adminUser.getAccount();
  this.parent.pageLoading = false;
  //console.log("type:", parent.type)
  //this.ref = this.db.playersCollection
  //this.usersRef = this.db.usersCollection.doc(this.email).collection("users")
  dashboards.getUsers();
  dashboards.getAllPlayers();
};

dashboards.getAllPlayers = function() {
  dashboards.parent.allPlayers = {
    count: "...",
    offline: "...",
    online: "...",
    paid: "...",
    expired: "...",
  };
  this.parent.refreshingPlayers = true;
  this.parent.adminUser.getPlayersSummary(dashboards.updatePlayers);
  //this.parent.adminUser.clearServerCache()
};
dashboards.updatePlayers = function(res) {
  dashboards.parent.onlinePlayers = 0;
  dashboards.parent.offlinePlayers = 0;
  if (res.status) {
    dashboards.parent.allPlayers.count = res.data.count;
    dashboards.parent.allPlayers.online = res.data.online;
    dashboards.parent.allPlayers.offline = res.data.offline;
    dashboards.parent.allPlayers.paid = res.data.paid;
    dashboards.parent.allPlayers.expired = res.data.expired;
  } else {
    console.error(res.error_msg);
    //Vue.prototype.$toastr("error", res.error_msg);
  }
  dashboards.parent.refreshingPlayers = false;
};
dashboards.updateUsers = function(res) {
  if (res.status) {
    dashboards.parent.allusers = res.data;
  } else {
    console.error(res.error_msg);
    //Vue.prototype.$toastr("error", res.error_msg);
  }
  dashboards.parent.refreshingUsers = false;
};
dashboards.getInvoices = async () => {
  return await dashboards.parent.adminUser.getInvoices();
};
dashboards.getUsers = function() {
  dashboards.parent.allusers = [];
  this.parent.refreshingUsers = true;
  this.parent.adminUser.getAllUsers(this.updateUsers);
};

export { dashboards };
